<template>
  <div :style="{ borderBottom: '1px solid var(--p-content-border-color)' }">
    <button
      :style="{ width: '100%', display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', background: 'transparent', border: 0, cursor: 'pointer', fontFamily: 'inherit' }"
      @click="toggle"
    >
      <i :class="`pi pi-${icon}`" :style="{ fontSize: '12px', color: 'var(--p-surface-400)', width: '14px' }" />
      <span :style="{ flex: 1, textAlign: 'left', fontSize: '13px', fontWeight: 700, color: 'var(--p-text-color)' }">{{ label }}</span>
      <CountPill v-if="total != null" :sel="count" :total="total" />
      <Badge v-else-if="count > 0" :n="count" />
      <i :class="`pi pi-chevron-${isOpen ? 'down' : 'right'}`" :style="{ fontSize: '10px', color: 'var(--p-surface-400)' }" />
    </button>
    <div v-if="isOpen" :style="{ padding: '0 8px 9px' }"><slot /></div>
  </div>
</template>

<script setup>
// Collapsible section container for sidebar fields. Ported from fql-search.jsx
// SectionShell. Supports parent-controlled open via `open` + @toggle.
import { ref, computed } from 'vue'
import { Badge, CountPill } from './bits.js'

const props = defineProps({
  icon: { type: String, default: 'tag' },
  label: { type: String, default: '' },
  count: { type: Number, default: 0 },
  // Absent when the section does not know how many there are in all.
  total: { type: Number, default: null },
  defaultOpen: { type: Boolean, default: false },
  open: { type: Boolean, default: null },
})
const emit = defineEmits(['toggle'])

const openState = ref(props.defaultOpen)
const isOpen = computed(() => (props.open != null ? props.open : openState.value))
function toggle() {
  if (props.open != null) emit('toggle', !isOpen.value)
  else openState.value = !openState.value
}
</script>
